import { render, staticRenderFns } from "./NewProfile.vue?vue&type=template&id=7dbc57de"
import script from "./NewProfile.vue?vue&type=script&lang=js"
export * from "./NewProfile.vue?vue&type=script&lang=js"
import style0 from "./NewProfile.vue?vue&type=style&index=0&id=7dbc57de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports